import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * Removes a clause from the rules edit page
 * @param clauseId the id of the clause to remove
 * @param sectionType the section that the clause belongs to (action, conditional, exception)
 */
export default select({
    optionState: function () { return store.inboxRulesEditState; },
})(action('removeClause')(function removeClause(clauseId, sectionType, state) {
    var optionState = state.optionState;
    optionState.clauseMap.delete(clauseId);
    if (sectionType == 'conditional') {
        var indexToDelete = optionState.conditionalClauseIds.indexOf(clauseId);
        optionState.conditionalClauseIds.splice(indexToDelete, 1);
    }
    else if (sectionType == 'action') {
        var indexToDelete = optionState.actionClauseIds.indexOf(clauseId);
        optionState.actionClauseIds.splice(indexToDelete, 1);
    }
    else if (sectionType == 'exception') {
        var indexToDelete = optionState.exceptionClauseIds.indexOf(clauseId);
        optionState.exceptionClauseIds.splice(indexToDelete, 1);
    }
    else {
        throw new Error('Cannot remove clause in section type that does not exist');
    }
}));
//# sourceMappingURL=removeClause.js.map